import {getNestedValue, interpolate} from "./interpolate";
import type {Dictionary, Locale, TranslateFunction} from "./types";
import {defaultLocale} from "./types";

/**
 * Translator class for use in controllers and services
 * Creates a new instance for each request (no singleton issues)
 */
export class Translator {
    constructor(
        private dict: Dictionary,
        private locale: Locale = defaultLocale,
    ) {}

    /**
     * Get current locale
     */
    getLocale(): Locale {
        return this.locale;
    }

    /**
     * Translate a key with optional interpolation and plural support
     *
     * @example
     * translator.t("common.readMore") // "Read more"
     * translator.t("destination.welcome", { name: "Rocky Point" }) // "Welcome to Rocky Point"
     * translator.t("search.guestsCount", { count: 2 }) // "2 Guests"
     */
    t: TranslateFunction = (key, params) => {
        const template = getNestedValue(this.dict as unknown as Record<string, unknown>, key);
        return interpolate(template, params, this.locale);
    };
}

/**
 * Factory function to create a Translator instance
 */
export function createTranslator(dict: Dictionary, locale: Locale = defaultLocale): Translator {
    return new Translator(dict, locale);
}
